import { render, staticRenderFns } from "./GradeBookList.vue?vue&type=template&id=f8d98336&"
import script from "./GradeBookList.vue?vue&type=script&lang=js&"
export * from "./GradeBookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports